<template>
  <div class="myInfo">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt /> 个人资料
      </h5>
    </div>
    <div class="info">
      <div class="top">
        <div class="upload display-flex align-items-center">
          <div class="lf">
            <span>上传头像</span>
            <img v-if="info.headimg" :src="info.headimg" alt />
            <img v-else src="../../assets/img/header.jpg" alt />
          </div>
          <div class="rg">
            <div class="imgUpload">
              <button type="button" class="look" @click="isShowModal = true">
                查看
              </button>
              <label class="uploadImg" for="uploadImg">重新上传</label>
              <input
                @change="uploadHeader"
                type="file"
                id="uploadImg"
                style="display: none;"
                accept="image/png, image/jpeg, image/jpg, image/gif"
              />
              <!-- <Upload
                ref="upload"
                :on-success="handleSuccess"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="2048"
                type="drag"
                action="http://121.37.247.227:1272/file/uploadToPath"
              >
                <span>重新上传</span>
              </Upload>-->
            </div>
            <p>建议上传图片尺寸:100*100</p>
          </div>
        </div>
      </div>
      <div class="from">
        <Form
          ref="from"
          :model="info"
          :rules="rules"
          :label-width="80"
          :hide-required-mark="true"
        >
          <div class="input">
            <FormItem label="姓名" prop="name">
              <Input
                type="text"
                v-model="info.name"
                placeholder="请输入姓名"
              ></Input>
            </FormItem>
            <FormItem label="性别" prop="sex">
              <Select v-model="info.sex" placeholder="请选择性别">
                <Option value="0">男</Option>
                <Option value="1">女</Option>
              </Select>
            </FormItem>
            <FormItem label="年龄" prop="age">
              <Input
                type="number"
                v-model="info.age"
                placeholder="请输入年龄"
              ></Input>
            </FormItem>
          </div>
          <div class="city display-flex">
            <!-- {{ typeof info.province }}{{ typeof province[24].id }} -->
            <FormItem label="所在城市" prop="province">
              <div class="item">
                <Select
                  v-model="info.province"
                  @on-change="handleChangePro"
                  placeholder="省份"
                >
                  <Option
                    :value="item.id"
                    v-for="item in province"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </div>
            </FormItem>
            <FormItem label prop="city">
              <div class="item">
                <Select
                  v-model="info.city"
                  @on-change="handleChangeCity"
                  placeholder="市"
                >
                  <Option
                    :value="item.id"
                    v-for="item in city"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </div>
            </FormItem>
            <FormItem label>
              <div class="item">
                <Select v-model="info.county" placeholder="区/县">
                  <Option
                    :value="item.id"
                    v-for="item in county"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </div>
            </FormItem>
          </div>

          <FormItem>
            <Button
              type="primary"
              :loading="btnLoading"
              class="confirm"
              @click="handleSubmit('from')"
              >确认</Button
            >
            <Button
              class="back"
              @click="$router.back()"
              style="margin-left: 20px;"
              >返回</Button
            >
          </FormItem>
        </Form>
      </div>
    </div>
    <Modal
      v-model="isShowModal"
      footer-hide
      :closable="false"
      width="600"
      class-name="vertical-center-modal"
    >
      <div class="modal">
        <img
          class="closeIcon"
          @click="isShowModal = false"
          src="../../assets/img/close.png"
        />
        <img
          v-if="info.headimg"
          id="headerImage"
          class="headerImage"
          :src="info.headimg"
          alt
        />
        <img v-else src="../../assets/img/header.jpg" alt />
      </div>
    </Modal>
  </div>
</template>

<script>
import { postData, showLoading, postUpload } from "../../assets/api/api.js";
export default {
  name: "myInfo",
  components: {},
  data() {
    return {
      isShowModal: false,
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        sex: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        // age: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        province: [
          { required: true, message: "省份不能为空", trigger: "change" },
        ],
        city: [{ required: true, message: "城市不能为空", trigger: "change" }],
        // county: [{ required: true, message: "县城不能为空", trigger: "blur" }],
      },
      province: [],
      city: [],
      county: [],
      info: {
        headimg: "",
        name: "",
        sex: "",
        age: "",
        province: "",
        city: "",
        county: "",
      },
      btnLoading: false,
    };
  },
  created() {
    this.loadUserData();
  },
  mounted() {},
  computed: {},
  methods: {
    loadProvince(cityId, countyId) {
      postData("area/list", {}).then((res) => {
        this.province = res.data.map((i) => {
          i.id = i.id.toString();
          return i;
        });
        if (cityId) {
          this.loadCity(cityId, countyId);
        }
      });
    },
    loadCity(cityId, countyId) {
      postData("area/list", { id: cityId }).then((res) => {
        this.city = res.data.map((i) => {
          i.id = i.id.toString();
          return i;
        });

        this.county = [];
        if (countyId) {
          this.loadCounty(countyId);
        }
      });
    },
    loadCounty(id) {
      postData("area/list", { id: id }).then((res) => {
        this.county = res.data.map((i) => {
          i.id = i.id.toString();
          return i;
        });
      });
    },
    handleChangePro(val) {
      if (val) {
        postData("area/list", { id: val }).then((res) => {
          this.city = res.data.map((i) => {
            i.id = i.id.toString();
            return i;
          });
          this.county = [];
          this.info.city = "";
          this.info.county = "";
        });
      }
    },
    handleChangeCity(val) {
      if (val) {
        postData("area/list", { id: val }).then((res) => {
          this.county = res.data.map((i) => {
            i.id = i.id.toString();
            return i;
          });
          this.info.county = "";
        });
      }
    },

    loadUserData() {
      var params = {};
      showLoading();
      postData("student/find", params).then((res) => {
        if (res.data.address) {
          res.data.province = res.data.address.split(",")[0];
          res.data.city = res.data.address.split(",")[1];
          res.data.county = res.data.address.split(",")[2];
        }
        this.loadProvince(res.data.province, res.data.city);
        this.info.headimg = res.data.headimg || "";
        this.info.name = res.data.name || "";
        this.info.sex = res.data.sex || "";
        this.info.age = res.data.age || "";
        this.info.province = res.data.province || "";
        this.info.city = res.data.city || "";
        this.info.county = res.data.county || "";
      });
    },
    handleSubmit(name) {
      const { info } = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          var address = info.county
            ? `${info.province},${info.city},${info.county}`
            : `${info.province},${info.city}`;
          var params = {
            headimg: info.headimg,
            name: info.name,
            sex: info.sex,
            age: info.age,
            address: address,
          };
          this.btnLoading = true;
          postData("student/update", params)
            .then((res) => {
              this.$Message.success("修改成功");
              this.btnLoading = false;
              var userData = this.$store.state.master;
              userData.user.name = info.name;
              if (localStorage.getItem("master")) {
                localStorage.setItem("master", JSON.stringify(userData));
              } else if (sessionStorage.getItem("master")) {
                sessionStorage.setItem("master", JSON.stringify(userData));
              }
              this.$store.commit("setMaster", userData);
              setTimeout(() => {
                this.$router.back()
              },1500)
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上传头像
    uploadHeader(e) {
      const formData = new FormData();
      var file = e.target.files[0];
      if (file) {
        formData.append("file", file);
        postUpload("file/uploadToPath", formData).then((res) => {
          this.$Message.success("头像上传成功");
          this.info.headimg = res.data;
        });
      }
    },
  },
};
</script>
<style>
.ivu-icon-ios-close:before {
  color: #222;
  font-size: 40px;
}
.city .ivu-form-item-content {
  margin-left: 0 !important;
}
.city .ivu-form-item:first-child .ivu-form-item-content {
  margin-left: 80px !important;
}
.myInfo .back {
  width: 100px;
  height: 40px;
  background: rgba(34, 34, 34, 1) !important;
  color: #fff;
  border-radius: 4px;
  line-height: 40px;
}
.myInfo .confirm {
  width: 120px;
  height: 40px;
  background: rgba(49, 175, 88, 1);
  border-radius: 4px;
  line-height: 40px;
}
.myInfo .input {
  width: 400px;
}
.myInfo .uploadImg {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  width: 90px;
  height: 30px;
  background: rgba(49, 175, 88, 1);
  border-radius: 4px;
  display: inline-block;
  line-height: 30px;
  color: #fff;
  border: none;
}
.myInfo .ivu-input {
  line-height: 36px;
  height: 36px;
}
.myInfo .ivu-select-selection {
  line-height: 36px;
  height: 36px;
}
</style>

<style lang="scss" scoped>
.closeIcon {
  cursor: pointer;
  position: absolute;
  top: -30px;
  right: -30px;
  height: 30px;
  width: 30px;
}
#headerImage {
  width: 100%;
  display: block !important;
}
.myInfo {
  .city .item {
    margin-right: 10px;
    width: 110px;
    background: rgba(255, 255, 255, 1);
  }
  button {
    border: none;
    outline: none;
    cursor: pointer;
  }
  .info {
    padding-left: 95px;
    padding-top: 70px;
    padding-bottom: 160px;
    .top {
      margin-left: 15px;
      margin-bottom: 25px;
      .rg {
        p {
          color: rgba(153, 153, 153, 1);
          line-height: 20px;
        }
        .look {
          vertical-align: top;
          color: #fff;
          margin-right: 10px;
          width: 60px;
          height: 30px;
          line-height: 30px;
          background: rgba(0, 0, 0, 1);
          border-radius: 4px;
        }
      }
      .lf {
        span {
          display: inline-block;
          margin-top: 8px;
          margin-right: 8px;
        }
        img {
          margin-right: 20px;
          vertical-align: top;
          width: 80px;
          height: 80px;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
